// 금액 단위 마침표 -> 인니는 , 대신 . 을 사용
const addComma = (value: number) => {
  return value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

const addRpComma = (value: number) => {
  return value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};
// input 입력되며 콤마
const onChangeComma = (value) => {
  if (value == 0) return "";
  const comma = (value) => {
    value = String(value);
    return value.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, "$1,");
  };
  const uncomma = (value) => {
    value = String(value);
    return value.replace(/[^\d]+/g, "");
  };
  return comma(uncomma(value));
};
// 숫자만 남기기
const onlyNum = (value: string) => {
  let regex = /[^0-9]/g;
  return value.replace(regex, "");
};
// 숫자로 변형
const toNumber = (value: string) => {
  let regex = /[^0-9]/g;
  let result = value.replace(regex, "");

  return Number(result);
};
// 핸드폰번호 형식
const phoneNumFormat = (value: string) => {
  return onlyNum(value).replace(
    /(^02.{0}|^01.{1}|[0-9]{4,4})([0-9]{3,4})([0-9]{3,4})/g,
    "$1 - $2 - $3",
  );
};
// 인니 월 이름
const monthNames = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember",
];
// 날짜
const getNow = () => {
  const d = new Date();
  return `${d.getDate().toString().padStart(2, "0")} ${
    monthNames[d.getMonth()]
  } ${d.getFullYear()}`;
};
const getUTCNow = () => {
  const d = new Date();

  const y = d.getUTCFullYear().toString();
  const M = (d.getUTCMonth() + 1).toString().padStart(2, "0");
  const D = d.getUTCDate().toString().padStart(2, "0");
  const h = d.getUTCHours().toString().padStart(2, "0");
  const m = d.getUTCMinutes().toString().padStart(2, "0");
  const s = d.getUTCSeconds().toString().padStart(2, "0");
  const ms = d.getUTCMilliseconds().toString().padStart(3, "0");

  return `${y}${M}${D}${h}${m}${s}${ms}`;
};
const getNowString = () => {
  const d = new Date();
  const year = d.getFullYear().toString(); // 년
  const month = (d.getMonth() + 1).toString().padStart(2, "0"); // 월
  const day = d.getDate().toString().padStart(2, "0"); // 일
  const hours = d.getHours().toString().padStart(2, "0"); // 시
  const minutes = d.getMinutes().toString().padStart(2, "0"); // 분
  const seconds = d.getSeconds().toString().padStart(2, "0");
  const milliSeconds = d.getMilliseconds().toString().padStart(3, "0");
  return year + month + day + hours + minutes + seconds + milliSeconds;
};
const getDateString = (date: Date) => {
  const year = date.getFullYear().toString(); // 년
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 월
  const day = date.getDate().toString().padStart(2, "0"); // 일
  const hours = date.getHours().toString().padStart(2, "0"); // 시
  const minutes = date.getMinutes().toString().padStart(2, "0"); // 분
  const seconds = date.getSeconds().toString().padStart(2, "0"); // 초
  return year + month + day + hours + minutes + seconds;
};
const dateFormat = (value: string, type?: string) => {
  let data = "";
  let regex = /[^0-9]/g;
  let number = value.replace(regex, "");
  if (type === "date") {
    const match = number.substr(0, 8).match(/(\d{4})(\d{2})(\d{2})/);
    if (!match) return number;
    data = `${match[3]} ${monthNames[Number(match[2]) - 1] ?? match[2]} ${
      match[1]
    }`;
  } else if (type === "newDate") {
    data = number
      .substr(0, 14)
      .replace(
        /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/,
        "$1-$2-$3T$4:$5:$6",
      );
  } else {
    const match = number
      .substr(0, 12)
      .match(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})/);
    if (!match) return number;
    data = `${match[3]} ${monthNames[Number(match[2]) - 1] ?? match[2]} ${
      match[1]
    } ${match[4]}:${match[5]}`;
  }
  return data;
};

export default {
  addComma,
  addRpComma,
  onChangeComma,
  onlyNum,
  toNumber,
  phoneNumFormat,
  getNow,
  getNowString,
  getDateString,
  dateFormat,
  getUTCNow,
};
